import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/czym-jest-kakobuy-spreadsheet/page";
import SafetyGuidePage from "../pages/article/poradnik-bezpieczenstwa-kakobuy/page";
import HowToUsePage from "../pages/article/jak-korzystac-z-kakobuy-spreadsheet/page";
import SneakersPage from "../pages/article/kakobuy-spreadsheet-sneakers/page";
import ShippingPage from "../pages/article/kakobuy-dostawa-polska/page";
import BeginnerTipsPage from "../pages/article/kakobuy-porady-dla-poczatkujacych/page";
import ReviewPage from "../pages/article/kakobuy-recenzja-2026/page";
import ClothingPage from "../pages/article/kakobuy-spreadsheet-odziez/page";
import AlternativesPage from "../pages/article/kakobuy-alternatywy/page";
import BestFindsPage from "../pages/article/najlepsze-znaleziska-kakobuy-2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/czym-jest-kakobuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/poradnik-bezpieczenstwa-kakobuy",
    element: <SafetyGuidePage />,
  },
  {
    path: "/jak-korzystac-z-kakobuy-spreadsheet",
    element: <HowToUsePage />,
  },
  {
    path: "/kakobuy-spreadsheet-sneakers",
    element: <SneakersPage />,
  },
  {
    path: "/kakobuy-dostawa-polska",
    element: <ShippingPage />,
  },
  {
    path: "/kakobuy-porady-dla-poczatkujacych",
    element: <BeginnerTipsPage />,
  },
  {
    path: "/kakobuy-recenzja-2026",
    element: <ReviewPage />,
  },
  {
    path: "/kakobuy-spreadsheet-odziez",
    element: <ClothingPage />,
  },
  {
    path: "/kakobuy-alternatywy",
    element: <AlternativesPage />,
  },
  {
    path: "/najlepsze-znaleziska-kakobuy-2026",
    element: <BestFindsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;